import { ProductPriceWithName } from "../../../../../state/product-price/types"
import { Action, ADD_PRICE, HANDLE_PRICE_CHANGE, INITIALIZE_DISPLAYED_VALUES, REMOVE_PRICE } from "../actions/productPriceActions"
import { ProductPricesHandler } from "./productPriceHandler"

export type State = {
    displayedProductPrices: Map<string, ProductPriceWithName>,
 }

export const InitialState: State = {
    displayedProductPrices: new Map<string, ProductPriceWithName>(),
}

export const ProductPricesReducer = (state: State, action: Action): State => {
    const handler = ProductPricesHandler(state)
    switch (action.type) {
    case INITIALIZE_DISPLAYED_VALUES:
        return handler.initialize(action.payload)
    case ADD_PRICE:
        return handler.addPrice(action.payload)
    case REMOVE_PRICE:
        return handler.removePrice(action.payload)
    case HANDLE_PRICE_CHANGE:
        return handler.handlePriceChange(action.payload)
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./src/product/form/components/states/reducers/productPriceReducer.ts